import { render, staticRenderFns } from "./AskRecord.vue?vue&type=template&id=3c431610&"
import script from "./AskRecord.vue?vue&type=script&lang=js&"
export * from "./AskRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports